<abs-modals-and-alerts-component [(modalAction)]="openModal" (modalClosed)="close($event, 'openModal')"
  windowClass="modal-docked" sizeClass="modal-small">
  <abs-modals-and-alerts-content-component id="skip-confirmation-utf-modal-popup">
    <div>
        <img id="icon" src="assets/images/exclamation-triangle_96.png" alt="Ineligibility icon">
      <main class="modal-header" tabindex="0">
        <h1 style="display:none;">Fix for sonar issues</h1>
        <h2 id="skip-file-modal-container-heading" modal-title>
          {{cfetLabels.utf_doc_upload.utf_skip_for_now_heading}}</h2>
        <div class="corner-button">
          <button type="button" class="close-modal-button" tabindex="0" [attr.aria-label]="'Close'"
            (click)="close($event, 'openModal')" (keyup)="close($event,'openModal')">
            <em aria-label="Close" class="icon-close modal-close-icon" role="img"></em>
          </button>
        </div>
      </main>
      <section class="modal-body" id="body-content-section" modal-content tabindex="0">
        <p id="description" class="extra-space">{{cfetLabels.utf_doc_upload.utf_skip_for_now_desc_point1}}</p>
        <p id="description" class="extra-space">{{cfetLabels.utf_doc_upload.utf_skip_for_now_desc_point2}}</p>
        <p id="description">{{cfetLabels.utf_doc_upload.utf_skip_for_now_desc_point3}}</p>
        <p id="description">{{cfetLabels.utf_doc_upload.utf_skip_for_now_desc_point4}}</p>
      </section>
      <section class="row no-gutters" id="confirmation-buttons">
        <div class="col-md-6">
          <button type="button" id="btn-stay" (click)="close($event,'openModal')" (keyup)="close($event,'openModal')"
            class="btn btn-medium" tabindex="0"><em aria-label=""></em>
            {{cfetButtonLabels.button_labels.utf_go_back}}</button>
        </div>
        <div class="col-md-6">
          <button type="button" id="btn-skip" (click)="skipForNow($event)" (keyup.enter)="skipForNow($event)"
            class="btn btn-alt btn-medium" tabindex="0"><em aria-label=""></em>
            {{cfetButtonLabels.button_labels.skip_photo_upload_utf}}</button>
        </div>
      </section>
    </div>
  </abs-modals-and-alerts-content-component>
</abs-modals-and-alerts-component>